export default {
  home: {
    main: "Main",
  },
};
